import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const scenarios = ['Introducing a new kitten/cat to a resident cat.', 'Bonded cats that suddenly started fighting.', 'Long-term territorial wars (hissing, stalking, hiding).', "You are exhausted, stressed, and afraid of 'rehoming'."];
export function FightingSection() {
  return <section className="bg-[#0a0a0a] py-16 px-4 border-t border-gray-900 pt-[30px] pb-[30px]" data-id="element-13">
      <div className="max-w-3xl mx-auto text-center" data-id="element-14">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 leading-tight" data-id="element-15">
          Is your home a{' '}
          <span className="text-orange-500" data-id="element-16">feline battlefield?</span>
        </h2>
        <p className="text-gray-400 mb-10 text-lg" data-id="element-17">
          This blueprint was built for you if any of these sound familiar:
        </p>

        <ul className="space-y-4 text-left" data-id="element-18">
          {scenarios.map((item, i) => <li key={i} className="flex items-start gap-4 bg-gray-900/60 border border-gray-800 rounded-xl px-6 py-5" data-id="element-19">
              <CheckCircle2 className="w-6 h-6 text-orange-500 flex-shrink-0 mt-0.5" data-id="element-20" />
              <span className="text-white text-lg font-medium leading-snug" data-id="element-21">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}